<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="AmBp">
<div class="image1"><img alt="images/himg-6-1.jpg" src="images/himg-6-1.jpg"/></div>
<p class="noind" id="pz17-3"><b><span class="dcap">J</span></b>esus told His followers they were the salt of the earth. This was an obvious metaphor for how they should impact the world around them. Salt has many different uses. First, salt preserves food. Before refrigeration, people salted foods, which made them last significantly longer than they did when left unsalted. Salt also adds flavor to foods. Many foods would be bland and—to some—inedible without salt. So adding salt makes dishes more palatable. </p>
<p id="pz17-5">What does it mean when Jesus calls you to be the salt of the earth? Jesus uses those who love and follow Him to help preserve this fallen world that has turned its back on Him. Jesus also uses you to spread the Word in a way that is easier for others to understand, easier for them to hear and digest, by adding flavor and depth to your words as you share the gospel. Salt brings out distinct flavors in food, just as believers can bring out the words of God to impact listeners in a positive way. Those who know Jesus, radiate His joy, and share His love add flavor to the world. Look for ways today to be the salt of the earth in your words and actions. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter12.vue?48d373b4